import React, { useEffect, useState } from 'react'
import { GetById_ByFoodsAndParking_Reserve_Api, GetById_Reserve_Api, GetReserveDays_Reserve_Api } from '../../API/ReserveApi';
import { Button, Col, Row, Steps } from 'antd';
import { ReserveInfoComponent } from '../Reserve/ReserveInfoComponent';
import { ReservePlaceAndTimeComponent } from '../Reserve/ReservePlaceAndTimeComponent';
import { CloseOutlined, DeleteOutlined, DoubleLeftOutlined, DoubleRightOutlined, EditOutlined, PlusOutlined, PrinterOutlined, RollbackOutlined } from '@ant-design/icons';
import { ADayFoodsComponent } from './ADayFoodsComponent';
import { ParkingReserveComponent } from './ParkingReserveComponent';
import { AReserveFoodsAndParking_Step2_Component } from './AReserveFoodsAndParking_Step2_Component';
import { AReserveFoodsAndParking_Step1_Component } from './AReserveFoodsAndParking_Step1_Component';
import { DaysFoodsComponent } from './DaysFoodsComponent';
import { FactorComponent } from './FactorComponent';
import { PaymentComponent_FoodAndParking } from './PaymentComponent_FoodAndParking';
import { AdminBarComponent } from '../Admin/AdminBarComponent';
import { PrintFoodsComponent } from './PrintFoodsComponent';
import { PrintReserveInfoComponent } from '../Reserve/PrintReserveInfoComponent';
import { PrintFactorComponent } from './PrintFactorComponent';
import { PrintParkingComponent } from './PrintParkingComponent';
import { PrintFoodReserveSummary } from './PrintFoodReserveSummary';


export const AReserveFoodsAndParking = ({
    setLoading,
    showMessage,
    reserveId,
    onBackClick,
    onPayCompleted,
}) => {
    // ====================================================================== 
    const [reserve, setReserve] = useState();
    const [view, setView] = useState('foodPrint');
    const [version, setVersion] = useState(0);
    // ======================================================================
    useEffect(() => {
        loadReserve();
    }, [version]);
    // ======================================================================    
    const loadReserve = async () => {
        setLoading(true);
        try {
            const data = await GetById_ByFoodsAndParking_Reserve_Api(reserveId);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setReserve(data.messageData.data);
            }

            else {
                showMessage(data.message, "error");
                onBackClick();
            }
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }

    // تابع برای دریافت متن وضعیت
    const getStatusText = (status) => {
        switch (status) {
            case 'None':
                return 'بدون وضعیت';
            case 'Selecting':
                return 'در حال انتخاب';
            case 'Payed':
                return 'پرداخت شده';
            case 'Completed':
                return 'قطعی شده';
            case 'RejectByAdmin':
                return 'رد شده توسط ادمین';
            default:
                return 'نامشخص';
        }
    };

    // تابع برای دریافت رنگ وضعیت
    const getStatusColor = (status) => {
        switch (status) {
            case 'Selecting':
                return '#faad14'; // نارنجی
            case 'Payed':
                return '#52c41a'; // سبز
            case 'Completed':
                return '#1890ff'; // آبی
            case 'RejectByAdmin':
                return '#ff4d4f'; // قرمز
            case 'None':
            default:
                return '#8c8c8c'; // خاکستری
        }
    };
    // ======================================================================  
    return (
        <>

            {reserve && reserve?.foodAndParkingStatus == "Payed" ||
                reserve?.foodAndParkingStatus == "Completed" ?

                <>
                    {localStorage.getItem('role') == 'SuperAdmin' ||
                        localStorage.getItem('role') == 'Admin' ?

                        <AdminBarComponent
                            setLoading={setLoading}
                            showMessage={showMessage}
                            reserve={reserve}
                            setVersion={setVersion}
                            version={version}
                            reserveMode={false}
                            foodMode={true}
                        /> : <></>
                    }

                    <div className="no-print">
                        <Row className='sectionTitle' style={{ marginBottom: '10px' }}>
                            <Col xs={6} sm={6} md={6} lg={4} xl={4} style={{ textAlign: "right" }} >
                                <Button
                                    className='step-prev-btn btn-light'
                                    onClick={() => { onBackClick() }}
                                >
                                    <DoubleRightOutlined />
                                    <span className='step-prev-btn-title'>
                                        بازگشت
                                    </span>
                                </Button>

                            </Col>
                            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                <h2>
                                    رزرو {reserve.period.enableFoodReserve ? "غذا" : <></>}

                                    {reserve.period.enableParkingReserve ? "/پارکینگ" : <></>}
                                </h2>
                                {/* نمایش وضعیت */}
                                    {reserve?.foodAndParkingStatus && reserve.foodAndParkingStatus !== 'None' && (
                                        <span 
                                            style={{
                                                backgroundColor: getStatusColor(reserve.foodAndParkingStatus),
                                                color: 'white',
                                                padding: '4px 12px',
                                                borderRadius: '16px',
                                                fontSize: '14px',
                                                fontWeight: 'bold',
                                                marginRight: '10px'
                                            }}
                                        >
                                            {getStatusText(reserve.foodAndParkingStatus)}
                                        </span>
                                    )}
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={12} xl={12} style={{ textAlign: "left" }} >
                                <Row>
                                    {reserve.period.enableFoodReserve ? <>
                                        <Col>
                                            <Button
                                                className={'step-next-btn btn-primary'}
                                                onClick={() => { setView("foodPrint"); setTimeout(() => window.print(), 500); }}
                                            >
                                                <span className='step-next-btn-title'>
                                                    چاپ فرم تحویل غذا
                                                </span>
                                                <PrinterOutlined />
                                            </Button>
                                        </Col>


                                        <Col>
                                            <Button
                                                className={'step-next-btn btn-info'}
                                                onClick={() => { setView("factorPrint"); setTimeout(() => window.print(), 500); }}
                                            >
                                                <span className='step-next-btn-title'>
                                                    چاپ فاکتور غذا
                                                </span>
                                                <PrinterOutlined />
                                            </Button>
                                        </Col></> : <></>
                                    }

                                    {reserve.period.enableParkingReserve ? <>
                                        <Col>
                                            <Button
                                                className={'step-next-btn btn-warning'}
                                                onClick={() => { setView("parkingPrint"); setTimeout(() => window.print(), 500); }}
                                            >
                                                <span className='step-next-btn-title'>
                                                    چاپ کارت پارکینگ
                                                </span>
                                                <PrinterOutlined />
                                            </Button>
                                        </Col></> : <></>
                                    }
                                </Row>


                            </Col>
                        </Row>
                    </div>

                    {view == 'foodPrintOld' ?
                        <div className="only-print">
                            <h2 style={{ textAlign: 'center' }}>
                                برگه تحویل غذا
                            </h2>
                        </div> : <></>}

                    {view == 'factorPrint' ?
                        <div className="only-print">
                            <h2 style={{ textAlign: 'center' }}>
                                فاکتور غذا
                            </h2>
                        </div> : <></>}

                    {view == 'parkingPrint' ?
                        <div className="only-print">
                            <h2 style={{ textAlign: 'center' }}>
                                کارت پارکینگ
                            </h2>
                        </div> : <></>}


                    <div className="no-print">
                        <ReserveInfoComponent adminMode={false} setLoading={setLoading} showMessage={showMessage} reserve={reserve} showTitle={false} />
                        <ReservePlaceAndTimeComponent setLoading={setLoading} showMessage={showMessage} reserve={reserve} showTitle={false} />
                    </div>

                    {(view != 'parkingPrint' && view != 'foodPrint') ?
                        <div className="only-print ">
                            <PrintReserveInfoComponent 
                             setLoading={setLoading} 
                                showMessage={showMessage}
                            reserve={reserve} 
                            type = 'Food'
                            />
                        </div> : <></>
                    }

                    {view == 'foodPrintOld' ?

                        <div className="only-print ">
                            <PrintFoodsComponent foods={reserve.foods} />
                        </div> : <></>
                    }

{view === 'foodPrint' && (
    <div className="only-print">
        <PrintFoodReserveSummary 
            reserve={reserve}
            foods={reserve.foods}
        />
    </div>
)}


                    {reserve.period.enableParkingReserve ? <>
                        <div className="no-print">
                            <ParkingReserveComponent reportMode={true} setLoading={setLoading} showMessage={showMessage} reserve={reserve} />
                        </div>
                    </> : <></>}

                    {view == 'parkingPrint' ?
                        <div className="only-print">
                            <PrintParkingComponent reserve={reserve} />
                        </div> : <></>
                    }
                    {reserve.period.enableFoodReserve ?
                        <div className="no-print">
                            <DaysFoodsComponent reportMode={true} setLoading={setLoading} showMessage={showMessage} reserve={reserve} />
                        </div>
                        : <></>
                    }

                    <div className="no-print">
                        <FactorComponent setLoading={setLoading} showMessage={showMessage} reserve={reserve} />
                    </div>

                    {view == 'factorPrint' ?
                        <div className="only-print">
                            <PrintFactorComponent foods={reserve.foods} />
                        </div> : <></>
                    }

                    <div className="no-print">
                        <PaymentComponent_FoodAndParking reportMode={true} reserve={reserve} period={reserve.period} setLoading={setLoading} showMessage={showMessage} />
                    </div>


                </> :
                <>
              
{reserve && localStorage.getItem('role') == 'Reception'  ?

                        <>
<div className="no-print">
                        <Row className='sectionTitle' style={{ marginBottom: '10px' }}>
                            <Col xs={6} sm={6} md={6} lg={4} xl={4} style={{ textAlign: "right" }} >
                                <Button
                                    className='step-prev-btn btn-light'
                                    onClick={() => { onBackClick() }}
                                >
                                    <DoubleRightOutlined />
                                    <span className='step-prev-btn-title'>
                                        بازگشت
                                    </span>
                                </Button>

                            </Col>
                            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                <h2>
                                    رزرو {reserve.period.enableFoodReserve ? "غذا" : <></>}

                                    {reserve.period.enableParkingReserve ? "/پارکینگ" : <></>}
                                </h2>
                                {/* نمایش وضعیت */}
                                    {reserve?.foodAndParkingStatus && reserve.foodAndParkingStatus !== 'None' && (
                                        <span 
                                            style={{
                                                backgroundColor: getStatusColor(reserve.foodAndParkingStatus),
                                                color: 'white',
                                                padding: '4px 12px',
                                                borderRadius: '16px',
                                                fontSize: '14px',
                                                fontWeight: 'bold',
                                                marginRight: '10px'
                                            }}
                                        >
                                            {getStatusText(reserve.foodAndParkingStatus)}
                                        </span>
                                    )}
                            </Col>
      </Row>
                    </div>


                        </> 
                        : 
                        <AReserveFoodsAndParking_Step1_Component
                        setLoading={setLoading}
                        showMessage={showMessage}
                        reserveId={reserveId}
                        onBackClick={onBackClick}
                        onPayCompleted={onPayCompleted}
                    />
                    }

                    
                </>
            }
        </>

    )
}
